import { z } from "zod";
import { UserRole } from "@carry/shared";
import { PublicIdSchema } from "./common";

export const AuthSession = z.object({
  user: z.object({
    id: PublicIdSchema,
    role: UserRole,
    name: z.string(),
    email: z.email().nullable(),
    line_linked: z.boolean(),
  }),
  expires_at: z.iso.datetime({ offset: true }),
});

export type AuthSessionDto = z.infer<typeof AuthSession>;

export const TokenResponse = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
  expires_in: z.number().int(),
  user: z.object({
    id: PublicIdSchema,
    role: UserRole,
    name: z.string(),
    email: z.email().nullable(),
    line_linked: z.boolean(),
  }),
});

export type TokenResponseDto = z.infer<typeof TokenResponse>;
